// This file is required in order to loading env.js to work
// We can't conditionally import env.js only for development
// do to webpack dependency resolution prioritization.
// see https://kargox.atlassian.net/l/c/XJdjmF90 for more info.
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  require('./env');
}
